import React, { useEffect, useState } from "react";
import axios from "axios";
import { useParams, useNavigate, Link } from "react-router-dom";
import config from '../../config';

function ShareholderDetails() {
    const { id } = useParams();
    const [shareholder, setShareholder] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState('');
    const [activeLanguage, setActiveLanguage] = useState('en');
    const navigate = useNavigate();

    const fetchShareholderDetails = async () => {
        try {
            const response = await axios.get(`${config.BASE_URL}/api/admin/get-shareholder-admin/${id}`, { withCredentials: true });
            setShareholder(response.data);
        } catch (err) {
            setError('Failed to fetch shareholder details');
            console.error('Error fetching shareholder:', err);
        } finally {
            setLoading(false);
        }
    }

    useEffect(() => {
        fetchShareholderDetails();
    }, [id]);

    const handleDelete = async () => {
        const confirmDelete = window.confirm('Are you sure you want to delete this shareholder? This action cannot be undone.');
        if (!confirmDelete) return;

        try {
            await axios.delete(`${config.BASE_URL}/api/admin/delete-shareholder/${id}`, { withCredentials: true });
            navigate('/admin/shareholders');
        } catch (err) {
            setError('Failed to delete the shareholder');
            console.error('Error deleting shareholder:', err);
        }
    };

    if (loading) return <div className="dashboard"><div className="container"><p>Loading...</p></div></div>;
    if (error) return <div className="dashboard"><div className="container"><p className="error-message">{error}</p></div></div>;
    if (!shareholder) return <div className="dashboard"><div className="container"><p>Shareholder not found.</p></div></div>;

    return (
        <div className="dashboard project_detail_wrap">
            <div className="container">
                <h1 className="dash_title">Dashboard</h1>
                <div className="back_btn_wrap">
                    <button className="back-btn" onClick={() => navigate(-1)}>Go Back</button>
                </div>

                {/* Language Tabs */}
                <div className="language-tabs" style={{ marginBottom: '20px' }}>
                    <button 
                        type="button" 
                        className={`tab-btn ${activeLanguage === 'en' ? 'active' : ''}`}
                        onClick={() => setActiveLanguage('en')}
                        style={{
                            padding: '10px 20px',
                            marginRight: '10px',
                            backgroundColor: activeLanguage === 'en' ? '#007bff' : '#f8f9fa',
                            color: activeLanguage === 'en' ? 'white' : 'black',
                            border: '1px solid #ddd',
                            cursor: 'pointer',
                            borderRadius: '4px'
                        }}
                    >
                        English
                    </button>
                    <button 
                        type="button" 
                        className={`tab-btn ${activeLanguage === 'es' ? 'active' : ''}`}
                        onClick={() => setActiveLanguage('es')}
                        style={{
                            padding: '10px 20px',
                            backgroundColor: activeLanguage === 'es' ? '#007bff' : '#f8f9fa',
                            color: activeLanguage === 'es' ? 'white' : 'black',
                            border: '1px solid #ddd',
                            cursor: 'pointer',
                            borderRadius: '4px'
                        }}
                    >
                        Spanish
                    </button>
                </div>

                <div className="main-section">
                    <div className="projects">
                        <div className="projects-inner">
                            {/* English Content */}
                            {activeLanguage === 'en' && (
                                <div className="language-content">
                                    <h3 style={{ marginBottom: '20px', color: '#007bff' }}>English Content</h3>

                                    <div className="detail_item">
                                        <h2>Language</h2>
                                        <div className="detail_item_inner">
                                            <p>{shareholder.language || 'en'}</p>
                                        </div>
                                    </div>

                                    <div className="detail_item">
                                        <h2>Title</h2>
                                        <div className="detail_item_inner">
                                            <p>{shareholder.title || 'No title provided'}</p>
                                        </div>
                                    </div>

                                    {/* <div className="detail_item">
                                        <h2>Slug</h2>
                                        <div className="detail_item_inner">
                                            <p>{shareholder.slug || 'No slug provided'}</p>
                                        </div>
                                    </div> */}

                                    <div className="detail_item">
                                        <h2>Description</h2>
                                        <div className="detail_item_inner">
                                            <p>{shareholder.description || 'No description provided'}</p>
                                        </div>
                                    </div>

                                    <div className="detail_item">
                                        <h2>Led</h2>
                                        <div className="detail_item_inner">
                                            <p>{shareholder.led || 'N/A'}</p>
                                        </div>
                                    </div>

                                    <div className="detail_item">
                                        <h2>Space</h2>
                                        <div className="detail_item_inner">
                                            <p>{shareholder.space || 'N/A'}</p>
                                        </div>
                                    </div>
                                </div>
                            )}

                            {/* Spanish Content */}
                            {activeLanguage === 'es' && (
                                <div className="language-content">
                                    <h3 style={{ marginBottom: '20px', color: '#007bff' }}>Spanish Content</h3>

                                    <div className="detail_item">
                                        <h2>Language</h2>
                                        <div className="detail_item_inner">
                                            <p>{shareholder.spanishData?.language || 'es'}</p>
                                        </div>
                                    </div>

                                    <div className="detail_item">
                                        <h2>Title</h2>
                                        <div className="detail_item_inner">
                                            <p>{shareholder.spanishData?.title || 'No se proporcionó título'}</p>
                                        </div>
                                    </div>

                                    {/* <div className="detail_item">
                                        <h2>Slug</h2>
                                        <div className="detail_item_inner">
                                            <p>{shareholder.spanishData?.slug || 'No se proporcionó slug'}</p>
                                        </div>
                                    </div> */}

                                    <div className="detail_item">
                                        <h2>Description</h2>
                                        <div className="detail_item_inner">
                                            <p>{shareholder.spanishData?.description || 'No se proporcionó descripción'}</p>
                                        </div>
                                    </div>

                                    <div className="detail_item">
                                        <h2>Led</h2>
                                        <div className="detail_item_inner">
                                            <p>{shareholder.spanishData?.led || 'N/A'}</p>
                                        </div>
                                    </div>

                                    <div className="detail_item">
                                        <h2>Space</h2>
                                        <div className="detail_item_inner">
                                            <p>{shareholder.spanishData?.space || 'N/A'}</p>
                                        </div>
                                    </div>

                                    {!shareholder.spanishData?.title && !shareholder.spanishData?.description && !shareholder.spanishData?.slug && !shareholder.spanishData?.led && !shareholder.spanishData?.space && (
                                        <div style={{ 
                                            padding: '15px', 
                                            backgroundColor: '#f8f9fa', 
                                            border: '1px solid #dee2e6', 
                                            borderRadius: '4px',
                                            marginTop: '10px'
                                        }}>
                                            <p style={{ margin: 0, color: '#6c757d', fontStyle: 'italic' }}>
                                                No Spanish translation available for this shareholder.
                                            </p>
                                        </div>
                                    )}
                                </div>
                            )}

                            {/* Featured Image - Always Visible */}
                            <div className="detail_item">
                                <div className="detail_banner_wrap">
                                    <div className="detail_img_grid">
                                        {shareholder.featuredImage ? (
                                            <div className="detail_img_item">
                                                <h2>Featured Image</h2>
                                                <div className="banner_img_wrap">
                                                    <img src={`${config.BASE_URL}${shareholder.featuredImage}`} alt="Featured" style={{ maxWidth: '100%', height: 'auto' }} />
                                                </div>
                                            </div>
                                        ) : (
                                            <div>
                                                <h2>Featured Image</h2>
                                                <p>No image available.</p>
                                            </div>
                                        )}
                                    </div>
                                </div>
                            </div>

                            {/* Clients Gallery */}
                            <div className="detail_item">
                                <h2>Clients</h2>
                                <div className="detail_item_inner gallery_inner">
                                    <div className="detail_img_grid">
                                        {shareholder.clients && shareholder.clients.length > 0 ? (
                                            shareholder.clients.map((image, index) => (
                                                <div className="detail_img_item" key={index}>
                                                    <img src={`${config.BASE_URL}${image}`} alt={`Shareholder client image ${index}`} />
                                                </div>
                                            ))
                                        ) : (
                                            <p>No images available.</p>
                                        )}
                                    </div>
                                </div>
                            </div>

                            {/* English Services */}
                            {activeLanguage === 'en' && (
                            <div className="add_field textareaField repeaterFields">
                                    <h2><b>Services (English)</b></h2>
                                    {shareholder?.services && shareholder.services.length > 0 ? (
                                        shareholder.services.map((field, index) => (
                                    <div key={index} className="singleReapterFieldContent update displayContent">
                                        <div className="detail_item">
                                            <h2>Title</h2>
                                            <div className="detail_item_inner">
                                                <p>{field.title}</p>
                                            </div>
                                        </div>
                                        <div className="detail_item">
                                            <h2>Description</h2>
                                            <div className="detail_item_inner">
                                                <p>{field.description}</p>
                                            </div>
                                        </div>
                                        <div className="detail_item">
                                            <h2>Image</h2>
                                            {field?.image ? (
                                                <div className="detail_img_item">
                                                    <div className="banner_img_wrap">
                                                        <img src={`${config.BASE_URL}${field?.image}`} alt={`${index}`} />
                                                    </div>
                                                </div>
                                            ) : <p>No Image added</p>}
                                        </div>
                                    </div>
                                        ))
                                    ) : (
                                        <p>No English services available.</p>
                                    )}
                                </div>
                            )}

                            {/* Spanish Services */}
                            {activeLanguage === 'es' && (
                                <div className="add_field textareaField repeaterFields">
                                    <h2><b>Services (Spanish)</b></h2>
                                    {shareholder?.spanishData?.services && shareholder.spanishData.services.length > 0 ? (
                                        shareholder.spanishData.services.map((field, index) => (
                                            <div key={index} className="singleReapterFieldContent update displayContent">
                                                <div className="detail_item">
                                                    <h2>Title</h2>
                                                    <div className="detail_item_inner">
                                                        <p>{field.title}</p>
                                                    </div>
                                                </div>
                                                <div className="detail_item">
                                                    <h2>Description</h2>
                                                    <div className="detail_item_inner">
                                                        <p>{field.description}</p>
                                                    </div>
                                                </div>
                                                <div className="detail_item">
                                                    <h2>Image</h2>
                                                    {field?.image ? (
                                                        <div className="detail_img_item">
                                                            <div className="banner_img_wrap">
                                                                <img src={`${config.BASE_URL}${field?.image}`} alt={`${index}`} />
                                                            </div>
                                                        </div>
                                                    ) : <p>No Image added</p>}
                                                </div>
                                            </div>
                                        ))
                                    ) : (
                                        <p>No  services available.</p>
                                    )}
                            </div>
                            )}

                            {/* English Reviews */}
                            {activeLanguage === 'en' && (
                            <div className="add_field textareaField repeaterFields">
                                    <h2><b>Reviews (English)</b></h2>
                                    {shareholder?.reviews && shareholder.reviews.length > 0 ? (
                                        shareholder.reviews.map((field, index) => (
                                    <div key={index} className="singleReapterFieldContent update displayContent">
                                        <div className="detail_item">
                                            <h2>Title</h2>
                                            <div className="detail_item_inner">
                                                <p>{field.title}</p>
                                            </div>
                                        </div>
                                        <div className="detail_item">
                                            <h2>Description</h2>
                                            <div className="detail_item_inner">
                                                <p>{field.description}</p>
                                            </div>
                                        </div>
                                        <div className="detail_item">
                                            <h2>Image</h2>
                                            {field?.image ? (
                                                <div className="detail_img_item">
                                                    <div className="banner_img_wrap">
                                                        <img src={`${config.BASE_URL}${field?.image}`} alt={`${index}`} />
                                                    </div>
                                                </div>
                                            ) : <p>No Image added</p>}
                                        </div>
                                    </div>
                                        ))
                                    ) : (
                                        <p>No English reviews available.</p>
                                    )}
                                </div>
                            )}

                            {/* Spanish Reviews */}
                            {activeLanguage === 'es' && (
                                <div className="add_field textareaField repeaterFields">
                                    <h2><b>Reviews (Spanish)</b></h2>
                                    {shareholder?.spanishData?.reviews && shareholder.spanishData.reviews.length > 0 ? (
                                        shareholder.spanishData.reviews.map((field, index) => (
                                            <div key={index} className="singleReapterFieldContent update displayContent">
                                                <div className="detail_item">
                                                    <h2>Title</h2>
                                                    <div className="detail_item_inner">
                                                        <p>{field.title}</p>
                                                    </div>
                                                </div>
                                                <div className="detail_item">
                                                    <h2>Description</h2>
                                                    <div className="detail_item_inner">
                                                        <p>{field.description}</p>
                                                    </div>
                                                </div>
                                                <div className="detail_item">
                                                    <h2>Image</h2>
                                                    {field?.image ? (
                                                        <div className="detail_img_item">
                                                            <div className="banner_img_wrap">
                                                                <img src={`${config.BASE_URL}${field?.image}`} alt={`${index}`} />
                                                            </div>
                                                        </div>
                                                    ) : <p>No Image added</p>}
                                                </div>
                                            </div>
                                        ))
                                    ) : (
                                        <p>No reviews available.</p>
                                    )}
                            </div>
                            )}

                            {/* English Portfolios */}
                            {activeLanguage === 'en' && (
                            <div className="detail_item">
                                    <h2>Portfolios (English)</h2>
                                <div className="detail_item_inner">
                                        {shareholder?.portfolios && shareholder.portfolios.length > 0 ? (
                                    <p>{shareholder.portfolios.map((item) => item?.title).join(', ')}</p>
                                        ) : (
                                            <p>No English portfolios available.</p>
                                        )}
                                    </div>
                                </div>
                            )}

                            {/* Spanish Portfolios */}
                            {activeLanguage === 'es' && (
                                <div className="detail_item">
                                    <h2>Portfolios (Spanish)</h2>
                                    <div className="detail_item_inner">
                                        {shareholder?.spanishData?.portfolios && shareholder.spanishData.portfolios.length > 0 ? (
                                            <p>{shareholder.spanishData.portfolios.map((item) => item?.title).join(', ')}</p>
                                        ) : (
                                            <p>No English portfolios available.</p>
                                        )}
                                </div>
                            </div>
                            )}

                            <div className="detail_item">
                                <h2>Is Featured</h2>
                                <div className="detail_item_inner">
                                    <p>{shareholder.isFeatured ? "Yes" : "No"}</p>
                                </div>
                            </div>

                            <div className="detail_item">
                                <h2>Is HomePage Featured</h2>
                                <div className="detail_item_inner">
                                    <p>{shareholder.isHomePageFeatured ? "Yes" : "No"}</p>
                                </div>
                            </div>

                            {/* Metadata */}
                            <div className="detail_item">
                                <h2>Shareholder Information</h2>
                                <div className="detail_item_inner">
                                    <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '20px', marginTop: '10px' }}>
                                        <div>
                                            <strong>Created:</strong>
                                            <p style={{ margin: '5px 0' }}>{shareholder.created_at ? new Date(shareholder.created_at).toLocaleDateString() : 'N/A'}</p>
                                        </div>
                                        <div>
                                            <strong>Last Updated:</strong>
                                            <p style={{ margin: '5px 0' }}>{shareholder.updated_at ? new Date(shareholder.updated_at).toLocaleDateString() : 'N/A'}</p>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            {/* Action Buttons */}
                            <div className="detail_project_btn_wrap">
                                <div className="detail_edit_del">
                                    <div className="btn_item">
                                        <button 
                                            className="detail_btns" 
                                            onClick={handleDelete}
                                            style={{
                                                backgroundColor: '#dc3545',
                                                color: 'white',
                                                border: 'none',
                                                padding: '10px 20px',
                                                borderRadius: '4px',
                                                cursor: 'pointer'
                                            }}
                                        >
                                            Delete
                                        </button>
                                    </div>
                                    <div className="btn_item">
                                        <Link 
                                            to={`/admin/update-shareholder/${shareholder._id}`} 
                                            className="update_detail detail_btns"
                                            style={{
                                                backgroundColor: '#28a745',
                                                color: 'white',
                                                textDecoration: 'none',
                                                padding: '10px 20px',
                                                borderRadius: '4px',
                                                display: 'inline-block'
                                            }}
                                        >
                                            Edit
                                        </Link>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default ShareholderDetails;
